module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAUBAMAAAAToVI7AAAAFVBMVEV1st19tt+Uw+WUxOWq0Or1+v33+v1H/1GQAAAAO0lEQVQY02NgIBUoYQqxhDpgCqZhCjEaCzCQBxxAGhlZkIWYwgyAJHOqAgExbHpJAFjdnEZkGCiRbB0AXeQFlWflpuIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/fm.png
// module id = 824
// module chunks = 0